<template>
  <a-modal
    :visible="visible"
    title="Crear formulario"
    wrapClassName="create-form-modal"
    @cancel="handleCancel"
  >
    <p>
      Completa los siguientes datos. Recuerda que este formulario podrás vincularlo a un nivel
      (grupo, resultado, motivo o submotivo) en tus tipificaciones. Puedes reutilizarlo las veces
      que necesites.
    </p>

    <CreateForm v-model:form-state="formState" />

    <template #footer>
      <a-button key="back" @click="handleCancel">Cancelar</a-button>
      <a-button
        key="submit"
        type="primary"
        id="create-form-button"
        :loading="loading"
        :disabled="isDisabled"
        @click="handleCreate"
      >
        Crear Formulario
      </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { Modal, message } from "ant-design-vue";
import { useRouter } from "vue-router";

import { ResponseError } from "@/app/shared/utils/httpManager";
import { formService } from "@/app/entities/services";
import { FormCreateBody } from "@/@types/entities/forms/services";

import CreateForm from "@/app/entities/components/modals/forms/forms/CreateForm.vue";

defineProps<{
  visible: boolean;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
}>();

const router = useRouter();

const loading = ref(false);
const formState = ref<FormCreateBody>({
  name: undefined,
  description: undefined,
});
const isDisabled = computed(() => !formState.value.name);

const closeModal = () => emit("update:visible", false);

const handleCancel = () => {
  if (isDisabled.value) {
    closeModal();
    return;
  }

  Modal.confirm({
    title: "¿Deseas descartar los cambios realizados?",
    content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
    centered: true,
    okText: "Sí, descartar cambios",
    cancelText: "No, seguir editando",
    onOk: () => closeModal(),
  });
};

const handleCreate = async () => {
  loading.value = true;

  try {
    const form = await formService.create(formState.value);

    message.success("Se ha creado el formulario");
    closeModal();

    router.push(`/operations/forms/${form.id}`);
  } catch (error) {
    let errorMessage = "No se pudo crear el formulario";

    if (error instanceof ResponseError) {
      console.error(error.data);
      errorMessage = error.errors;
    }

    message.error(errorMessage);
  }

  loading.value = false;
};
</script>

<style scoped lang="sass"></style>
